<!-- eslint-disable -->
<template lang="pug">
    form.fields(action="javascript://", @submit="sendForm")
        .fields__element(v-if="(user.isSuperadmin || user.type !== 'student') && pointsAccesses.length > 1")
            label.fields__label.fields__label--small {{ $i18n.t('fields.fields_typeSwitcher') }}
            cs-multiselect.fields__input(
                :options="pointsAccesses"
                v-model="form.pointsAccess"
                :custom-label="courseLabel"
                :placeholder="courseLabel(form.pointsAccess)"
                :multiple="false"
                :allow-empty="false"
            )
        template(v-if="user.isSuperadmin || user.type !== 'student'")
            .fields__element
                label.fields__label.fields__label--small {{ $i18n.tc('fields.fields_school', 0) }}
                cs-multiselect.fields__input(
                    :multiple="false",
                    :options="schools",
                    :show-labels="false",
                    label="name",
                    track-by="id",
                    :searchable="true",
                    :loading="loadingSchools",
                    @open="getSchools",
                    :placeholder="$i18n.t('common.common_placeholder_enterToSearch')",
                    v-model="form.school"
                )
                    span(slot="noResult") {{ $i18n.t('fields.fields_schoolNotFound') }}
            .fields__element
                label.fields__label.fields__label--small {{ $i18n.tc('fields.fields_grade', 0) }}
                cs-multiselect.fields__input(
                    :multiple="false",
                    :options="grades",
                    :show-labels="false",
                    label="name",
                    track-by="id",
                    :searchable="true",
                    :loading="loadingGrades",
                    :placeholder="gradesPlaceholder",
                    v-model="form.grade",
                    :disabled="isGradeDisabled",
                    @open="getGrades"
                )
                    span(slot="noResult") {{ $i18n.t('fields.fields_gradeNotFound') }}
            .fields__element
                label.fields__label.fields__label--small {{ $i18n.t('fields.fields_teacher') }}
                cs-multiselect.fields__input(
                    :multiple="false",
                    :options="teachers",
                    :show-labels="false",
                    track-by="id",
                    :searchable="true",
                    :loading="loadingTeachers",
                    :placeholder="teachersPlaceholder",
                    label="fullName",
                    v-model="form.teacher",
                    :disabled="isTeacherDisabled",
                    @open="getTeachers"
                )
                    span(slot="noResult") {{ $i18n.t('fields.fields_teacherNotFound') }}
        .fields__element
            label.fields__label.fields__label--small {{ $i18n.t('fields.fields_period') }}
            cs-datepicker.fields__input(
                :language="user.locale",
                v-model="form.date",
                :placeholder="$i18n.t('fields.fields_month')",
                :format="customFormatter",
                minimumView="month",
                maximumView="year"
            )
        .fields__element
        .fields__element.fields__element--fluid
            cs-button(
                color="blue",
                pattern="primary-outline",
                html-tag="a"
                href="javascript://"
                @click="resetResults",
                narrow
            )
                | {{ $i18n.t('fields.fields_dropParameters') }}
</template>

<script>
    /*eslint-disable*/
    import searchFieldsMixin from '../../../utils/searchFieldsMixin';
    import {mapState} from 'vuex';
    import _ from 'lodash';
    import moment from "moment";
    import searchParamsStore from '../utils/searchParamsStore';

    export default {
        mixins: [searchFieldsMixin, searchParamsStore],
        data() {
            return {
                schools: [],
                grades: [],
                teachers: [],
                form: {
                    school: null,
                    grade: null,
                    teacher: null,
                    date: null,
                    pointsAccess: ''
                },
                pointsAccesses: []
            }
        },
        watch: {
            '$route.query'(val) {
                if (_.isEmpty(val)) {
                    this.form = _.cloneDeep(this.localSearchParams) || {
                        school: null,
                        grade: null,
                        teacher: null,
                        date: null,
                        pointsAccess: '',
                    };
                }
            },
            'form.school'() {
                this.updateList()
            },
            'form.grade'() {
                this.updateList()
            },
            'form.teacher'() {
                this.updateList()
            },
            'form.date'() {
                this.updateList()
            },
            'form.pointsAccess'() {
                this.updateList()
            },
            'selectedCourse'() {
                this.form.pointsAccess = this.selectedCourse;
            },
        },
        props: ['schoolId', 'gradeId'],
        mounted() {
            this.pointsAccesses = this.user.pointsAccesses;
            if (this.user.type !== 'student' && this.$route.params.pointsAccess) {
                this.form.pointsAccess = this.$route.params.pointsAccess;
            } else if (this.user.type !== 'student' && !this.form.pointsAccess) {
                this.form.pointsAccess = this.user.pointsAccesses[0] || '';
            } else {
                this.form.pointsAccess = this.selectedCourse;
            }
            this.form.date = moment().format('YYYY-MM-DD');
            if (!this.user.isSuperadmin && this.user.type === 'admin') {
                this.form.school = this.user.school;
                this.sendForm();
            }
        },
        methods: {
            sendForm() {
                let form = _.cloneDeep(this.form);
                form.date = moment(this.form.date).format('YYYY-MM-DD');
                this.$emit('search', form);
            },
            resetResults() {
                if (this.user.type === 'admin') {
                    if (this.user.isSuperadmin) {
                        this.form.school = null;
                    } else {
                        this.form.school = this.user.school;
                    }
                }
                this.form.grade = null;
                this.form.teacher = null;
                this.form.date = moment().format('YYYY-MM-DD');
                this.$emit('search', this.form);
            },
            customFormatter(date) {
                return moment(date).format('MMM YYYY');
            },
            courseLabel(course) {
                if (course !== null) {
                    return this.$i18n.t('common.common_course_' + course)
                } else {
                    return this.$i18n.t('grade.grade_form_chooseCourse')
                }
            },
            updateList: _.debounce(function () {
                this.sendForm()
            }, 1000)
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
                selectedCourse: state => state.trainer.course
            })
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../assets/sass/fields/fields.scss";
</style>
